import { configure } from 'vee-validate';
import './yupAsyncValidations';
import './yupSyncValidations';

// Configuración global de vee-validate
configure({
  validateOnBlur: true, // Validar cuando el campo pierde el foco
  validateOnChange: true, // No validar en cambios
  validateOnInput: false, // No validar durante la escritura
  validateOnModelUpdate: true, // No validar cuando el modelo se actualiza
});

import { setYupLocales } from './yupEsLocale';

// Set Yup locales
setYupLocales();
